export const ALERT_DATE_RANGES_DIFFERENCE = 3;
export const ALERT_DELETE_TOAST_CLOSE_DELAY = 3000;
